export default {
  title: 'Profile Page',
  header: 'Profile'
}
